import { Amplify } from "aws-amplify";
import {
  confirmSignIn,
  confirmSignUp,
  fetchAuthSession,
  signIn,
  signOut,
  signUp,
} from "aws-amplify/auth";
import { config } from "../config.js";

/**
 * Cognito, configured for SRP.
 *
 * No hosted UI and no OAuth redirect: the pool has neither a domain nor
 * callback URLs, and an embeddable widget that bounces the user out to a
 * hosted login page and back would break the moment it is inside an iframe on
 * a partner's site. SRP keeps the whole exchange in the page.
 */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
      signUpVerificationMethod: "code",
      loginWith: { email: true },
    },
  },
});

/**
 * The id token, refreshed automatically when it is close to expiry.
 *
 * The id token rather than the access token because the API Gateway authorizer
 * is configured with the app client id as its audience, and only the id token
 * carries `aud`. It also carries `name` and `custom:timezone`, which the
 * handler builds its Principal from.
 */
export async function idToken(): Promise<string | undefined> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  } catch {
    return undefined;
  }
}

export { signIn, signOut, signUp, confirmSignUp, confirmSignIn, fetchAuthSession };
